import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { ListUsers } from "@/resources/User/ListUsers";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
export var EditElectionEventUsers = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId;
    var authContext = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var showUsers = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_READ);
    if (!showUsers) {
        return null;
    }
    return _jsx(ListUsers, { electionEventId: electionEventId, electionId: electionId });
};
